// extracted by mini-css-extract-plugin
module.exports = {"compress":"_2wucw","options":"_1vnTp","multi-panel":"_1iYR2","multiPanel":"_1iYR2","expand-icon":"qUjf-","expandIcon":"qUjf-"};